import { forwardRef } from "react";
import { CheckBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const PreferenceComponent = forwardRef(
  ({ title, checkedValue, titleBold = false, change }, ref) => {
    const { t } = useTranslation(["Preferences"]);

    return (
      <div className="m-4 d-flex justify-content-between align-items-center">
        <div className={`${titleBold ? "fw-600" : ""}`}>{title}</div>
        <div>
          <CheckBox
            ref={ref}
            checked={checkedValue}
            label={t("Email")}
            change={change}
          />
        </div>
      </div>
    );
  }
);
